import Header from '../../components/Header'
import RecipeInfo from '../../components/RecipeInfo'

const ById = () => (
  <>
    <Header />
    <div className="container">
      <RecipeInfo />
    </div>
  </>
)
export default ById
